/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ControlUncontainUserAction = {
    Enable: 'enable'
} as const;
export type ControlUncontainUserAction = typeof ControlUncontainUserAction[keyof typeof ControlUncontainUserAction];


export function ControlUncontainUserActionFromJSON(json: any): ControlUncontainUserAction {
    return ControlUncontainUserActionFromJSONTyped(json, false);
}

export function ControlUncontainUserActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlUncontainUserAction {
    return json as ControlUncontainUserAction;
}

export function ControlUncontainUserActionToJSON(value?: ControlUncontainUserAction | null): any {
    return value as any;
}

